"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
var _Tooltip = _interopRequireDefault(require("../../Tooltip/Tooltip"));
var _Typography = _interopRequireDefault(require("../../Typography"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    typography: {
      '-webkit-box-orient': 'vertical',
      display: '-webkit-box',
      lineHeight: '18px',
      // Default is 20px but we need 2 less to have total height of 36px
      overflow: 'hidden'
    },
    typographyMultiline: {
      '-webkit-line-clamp': 3
    },
    typographySingleLine: {
      '-webkit-line-clamp': 1
    },
    typographyStatusDisabled: {
      color: theme.palette.opacity.black[38]
    }
  };
});
var SingleConditionText = function SingleConditionText(props) {
  var children = props.children,
    multiline = props.multiline,
    TypographyProps = props.TypographyProps,
    isDisabled = props.isDisabled;
  var styles = useStyles();
  var _React$useState = React.useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    isOverflown = _React$useState2[0],
    setIsOverflown = _React$useState2[1];
  var text = /*#__PURE__*/React.createElement(_Typography["default"], (0, _extends2["default"])({
    ref: function ref(element) {
      if (element !== null) {
        setIsOverflown(element.scrollHeight > element.clientHeight);
      }
    },
    variant: "body1"
  }, TypographyProps, {
    className: (0, _classnames["default"])(styles.typography, multiline ? styles.typographyMultiline : styles.typographySingleLine, (0, _defineProperty2["default"])({}, styles.typographyStatusDisabled, isDisabled), TypographyProps === null || TypographyProps === void 0 ? void 0 : TypographyProps.className)
  }), children);
  return isOverflown ? /*#__PURE__*/React.createElement(_Tooltip["default"], {
    title: children
  }, text) : text;
};
SingleConditionText.displayName = 'SingleConditionText';
SingleConditionText.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  isDisabled: _propTypes["default"].bool,
  multiline: _propTypes["default"].bool,
  TypographyProps: _propTypes["default"].object
} : {};
var _default = SingleConditionText;
exports["default"] = _default;